export default {
    display: {
        template: 'Tab',
        defaultValue: '',
        label: 'Visibility',
        inputType: 'boxed',
        options: [
            { label: 'Visible', value: '' },
            { label: 'Hidden', value: 'none' },
        ],
    },
    justifyContent: {
        template: 'Tab',
        inputType: 'boxed',
        label: 'Horizontal Align',
        defaultValue: 'flex-start',
        options: [
            { label: 'Left', value: 'flex-start' },
            { label: 'Center', value: 'center' },
            { label: 'Right', value: 'flex-end' },
        ],
    },
    flexDirection: {
        template: 'Tab',
        inputType: 'boxed',
        label: 'Direction',
        defaultValue: 'row',
        options: [
            { label: 'Horizontal', value: 'row' },
            { label: 'Vertical', value: 'column' },
        ],
    },
    alignItems: {
        template: 'Tab',
        inputType: 'boxed',
        label: 'Vertical Align',
        defaultValue: 'flex-start',
        options: [
            { label: 'Top', value: 'flex-start' },
            { label: 'Center', value: 'center' },
            { label: 'Bottom', value: 'flex-end' },
        ],
    },

    borderRadius: {
        hoverable: true,
        isResponsible: true,
        label: 'Border Radius',
        template: 'BorderRadius',
    },
    _border: {
        hoverable: false,
        template: 'SimpleBorder',
    },
    boxShadow: {
        type: {
            label: 'Shadow',
            template: 'Tab',
            hoverable: true,
            inputType: 'boxed',
            defaultValue: 'none',
            options: [
                { label: 'None', value: 'none' },
                { label: 'Outer Shadow', value: '' },
                { label: 'Inner Shadow', value: 'inset' },
            ],
        },
        x: {
            hoverable: true,
            isResponsible: true,
            defaultValue: '',
            defaultUnit: 'px',
            template: 'Range',
            labelWidth: '98px',
            label: 'Horizontal',
            labelPosition: 'inline',
        },
        y: {
            hoverable: true,
            isResponsible: true,
            label: 'Vertical',
            defaultValue: '',
            defaultUnit: 'px',
            template: 'Range',
            labelWidth: '98px',
            labelPosition: 'inline',
        },
        blur: {
            hoverable: true,
            isResponsible: true,
            defaultValue: '',
            defaultUnit: 'px',
            template: 'Range',
            label: 'Shadow Blur Radius',
        },
        spread: {
            hoverable: true,
            isResponsible: true,
            defaultValue: '',
            defaultUnit: 'px',
            template: 'Range',
            label: 'Shadow Spread Radius',
        },
        color: {
            hoverable: true,
            label: 'Shadow Color',
            template: 'ColorPicker',
        },
    },
    color: {
        label: 'Color',
        hoverable: true,
        template: 'ColorPicker',
    },
    textAlign: {
        template: 'Tab',
        inputType: 'boxed',
        label: 'Alignment',
        isResponsible: true,
        defaultValue: 'left',
        options: [
            { label: 'Left', value: 'left', icon: 'far align-left' },
            { label: 'Center', value: 'center', icon: 'far align-center' },
            { label: 'Right', value: 'right', icon: 'far align-right' },
            { label: 'Justify', value: 'justify', icon: 'far align-justify' },
        ],
    },
    padding: {
        label: 'Padding',
        isResponsible: true,
        template: 'Spacing',
        options: [
            { name: 'top', label: 'Top' },
            { name: 'bottom', label: 'Bottom' },
            { name: 'left', label: 'Left' },
            { name: 'right', label: 'Right' },
        ],
    },
    fontSize: {
        label: 'Text Size',
        template: 'Range',
        defaultUnit: 'px',
        defaultValue: '16px',
        isResponsible: true,
    },
    fontFamily: {
        label: 'Font Family',
        template: 'Select',
        options: [{ name: 'Open Sans', value: 'opensans' }],
    },
    fontWeight: {
        template: 'Select',
        defaultValue: '400',
        label: 'Font Weight',
        options: [
            { name: 'Light - 200', value: '200' },
            { name: 'Regular - 400', value: '400' },
            { name: 'Medium - 500', value: '500' },
            { name: 'Bold - 600', value: '600' },
        ],
    },
    lineHeight: {
        label: 'Line Height',
        isResponsible: true,
        labelPosition: 'inline',
        template: 'LabeledUnitInput',
    },
    letterSpacing: {
        label: 'Spacing',
        defaultUnit: 'px',
        isResponsible: true,
        labelPosition: 'inline',
        template: 'LabeledUnitInput',
    },
    textTransform: {
        template: 'Tab',
        inputType: 'boxed',
        isResponsible: true,
        defaultValue: 'none',
        label: 'Text Transform',
        options: [
            { label: 'None', value: 'none' },
            { label: 'Uppercase', value: 'uppercase' },
            { label: 'Lowercase', value: 'lowercase' },
            { label: 'Capitalize', value: 'capitalize' },
        ],
    },
    transform: {
        rotateX: {
            max: 360,
            defaultValue: '',
            defaultUnit: 'deg',
            template: 'Range',
            label: 'Horizontal',
            labelWidth: '100px',
            placeholder: 'auto',
            labelPosition: 'inline',
        },
        rotateY: {
            max: 360,
            defaultValue: '',
            label: 'Vertical',
            defaultUnit: 'deg',
            template: 'Range',
            placeholder: 'auto',
            labelWidth: '100px',
            labelPosition: 'inline',
        },
        rotateZ: {
            max: 360,
            label: 'Z-Axis',
            defaultValue: '',
            template: 'Range',
            defaultUnit: 'deg',
            placeholder: 'auto',
            labelWidth: '100px',
            labelPosition: 'inline',
        },
        scale: {
            min: 0,
            max: 2,
            step: '0.1',
            defaultValue: '1',
            template: 'Range',
            labelWidth: '100px',
            labelPosition: 'inline',
        },
        translateX: {
            min: -100,
            max: 100,
            defaultValue: '',
            defaultUnit: '%',
            template: 'Range',
            label: 'Horizontal',
            placeholder: 'auto',
            labelWidth: '100px',
            labelPosition: 'inline',
        },
        translateY: {
            min: -100,
            max: 100,
            defaultValue: '',
            label: 'Vertical',
            defaultUnit: '%',
            template: 'Range',
            placeholder: 'auto',
            labelWidth: '100px',
            labelPosition: 'inline',
        },
        skewX: {
            max: 180,
            template: 'Range',
            defaultUnit: 'deg',
            label: 'Horizontal',
            placeholder: 'auto',
            labelWidth: '100px',
            labelPosition: 'inline',
        },
        skewY: {
            max: 180,
            label: 'Vertical',
            template: 'Range',
            defaultUnit: 'deg',
            placeholder: 'auto',
            labelWidth: '100px',
            labelPosition: 'inline',
        },
    },
    textDecoration: {
        type: {
            template: 'Tab',
            hoverable: true,
            inputType: 'boxed',
            defaultValue: 'none',
            label: 'Text Line Position',
            options: [
                { label: 'None', value: 'none' },
                { label: 'Under', value: 'underline' },
                { label: 'Over', value: 'overline' },
                {
                    label: 'Through',
                    value: 'line-through',
                },
            ],
        },
        style: {
            hoverable: true,
            template: 'Select',
            label: 'Text Line Style',
            options: [
                { name: 'Solid', value: 'solid' },
                { name: 'Double', value: 'double' },
                { name: 'Dotted', value: 'dotted' },
                { name: 'Dashed', value: 'dashed' },
                { name: 'Wavy', value: 'wavy' },
            ],
        },
        color: {
            hoverable: true,
            template: 'ColorPicker',
            label: 'Text Line Color',
        },
    },
    margin: {
        label: 'Margin',
        isResponsible: true,
        template: 'Spacing',
        options: [
            { name: 'top', label: 'Top' },
            { name: 'bottom', label: 'Bottom' },
            { name: 'left', label: 'Left' },
            { name: 'right', label: 'Right' },
        ],
    },
    width: {
        max: 100,
        info: 'Width of the content',
        label: 'Width',
        defaultUnit: '%',
        template: 'Range',
        path: 'style/width',
        placeholder: 'auto',
        isResponsible: true,
    },
    backgroundColor: {
        hoverable: true,
        inputType: 'color',
        template: 'ColorPicker',
        label: 'Background Color',
    },
    backgroundImage: {
        image: {
            label: 'URL',
            template: 'ImagePreview',
        },
        gradient: {
            hoverable: true,
            label: 'Gradient Background',
            template: 'BackgroundGradient',
        },
    },
    objectPosition: {
        label: 'Image Position',
        template: 'Select',
        defaultValue: '',
        options: [
            { name: 'Center', value: '' },
            { name: 'Top-Left Corner', value: '0 0' },
            { name: 'Top-Right Corner', value: '100% 0' },
            { name: 'Bottom-Left Corner', value: '0 100%' },
            { name: 'Bottom-Right Corner', value: '100% 100%' },
        ],
    },
    objectFit: {
        label: 'Image Fit',
        template: 'Tab',
        defaultValue: 'cover',
        inputType: 'boxed',
        options: [
            { label: 'Default', value: '' },
            { label: 'Cover', value: 'cover' },
            { label: 'Contain', value: 'contain' },
        ],
    },
    maxWidth: {
        max: 100,
        info:
            'Maximum width of the content Maximum width of the content Maximum width of the content Maximum width of the content Maximum width of the content Maximum width of the content Maximum width of the content',
        defaultUnit: '%',
        template: 'Range',
        label: 'Max Width',
        placeholder: 'auto',
        isResponsible: true,
    },
    minHeight: {
        min: 100,
        max: 1000,
        defaultUnit: 'px',
        template: 'Range',
        placeholder: 'auto',
        label: 'Min Height',
        isResponsible: true,
    },
    minWidth: {
        min: 50,
        max: 1000,
        defaultUnit: 'px',
        template: 'Range',
        placeholder: 'auto',
        label: 'Min Width',
        isResponsible: true,
    },
    height: {
        min: 100,
        max: 1000,
        label: 'Height',
        defaultUnit: 'px',
        template: 'Range',
        placeholder: 'auto',
        isResponsible: true,
    },
    maxHeight: {
        min: 100,
        max: 1000,
        defaultUnit: 'px',
        template: 'Range',
        placeholder: 'auto',
        label: 'Max Height',
        isResponsible: true,
    },
    overflowX: {
        label: 'Overflow-X',
        hoverable: true,
        template: 'Tab',
        inputType: 'boxed',
        isResponsible: true,
        defaultValue: 'left',
        options: [
            { label: 'Auto', value: 'auto' },
            { label: 'Scroll', value: 'scroll' },
            { label: 'Visible', value: 'visible' },
            { label: 'Hidden', value: 'hidden' },
        ],
    },
    overflowY: {
        label: 'Overflow-Y',
        hoverable: true,
        template: 'Tab',
        inputType: 'boxed',
        isResponsible: true,
        defaultValue: 'left',
        options: [
            { label: 'Auto', value: 'auto' },
            { label: 'Scroll', value: 'scroll' },
            { label: 'Visible', value: 'visible' },
            { label: 'Hidden', value: 'hidden' },
        ],
    },
    zIndex: {
        label: 'Z-Index',
        hoverable: true,
        template: 'Range',
        isResponsible: true,
        defaultValue: '',
        placeholder: 'auto',
    },
    backgroundSize: {
        template: 'Select',
        isResponsible: true,
        label: 'Background Size',
        options: [
            { name: 'Auto', value: 'auto' },
            { name: 'Cover', value: 'cover' },
            { name: 'Contain', value: 'contain' },
        ],
    },
    backgroundPosition: {
        template: 'Select',
        isResponsible: true,
        label: 'Background Position',
        options: [
            { name: 'Center', value: 'center' },
            { name: 'Center Top', value: 'top' },
            { name: 'Center Left', value: 'left' },
            { name: 'Center Right', value: 'right' },
            { name: 'Center Bottom', value: 'bottom' },
            { name: 'Top Left', value: '0 0' },
            { name: 'Top Right', value: '100% 0' },
            { name: 'Bottom Left', value: '0 100%' },
            { name: 'Bottom Right', value: '100% 100%' },
        ],
    },
    backgroundRepeat: {
        template: 'Tab',
        inputType: 'boxed',
        defaultValue: 'no-repeat',
        label: 'Background Image Repeat',
        options: [
            { label: 'Repeat', value: 'repeat' },
            { label: 'No Repeat', value: 'no-repeat' },
        ],
    },
    backgroundBlendMode: {
        template: 'Select',
        defaultValue: 'normal',
        label: 'Background Blend Mode',
        options: [
            { name: 'Normal', value: 'normal' },
            { name: 'Multiply', value: 'multiply' },
            { name: 'Hard Light', value: 'hard-light' },
            { name: 'Difference', value: 'difference' },
        ],
    },
    filter: {
        'hue-rotate': {
            max: 360,
            template: 'Range',
            defaultUnit: 'deg',
            label: 'Hue Rotate',
            labelWidth: '103px',
            defaultValue: '0deg',
            labelPosition: 'inline',
        },
        saturate: {
            min: 0,
            max: 200,
            defaultUnit: '%',
            template: 'Range',
            label: 'Saturation',
            labelWidth: '103px',
            defaultValue: '100%',
            labelPosition: 'inline',
        },
        brightness: {
            min: 0,
            max: 200,
            defaultUnit: '%',
            template: 'Range',
            label: 'Brightness',
            labelWidth: '103px',
            defaultValue: '100%',
            labelPosition: 'inline',
        },
        dropShadow: {
            hoverable: true,
            defaultUnit: 'px',
            template: 'Range',
            label: 'Drop Shadow',
        },
        contrast: {
            min: 0,
            max: 200,
            defaultUnit: '%',
            label: 'Contrast',
            template: 'Range',
            labelWidth: '103px',
            defaultValue: '100%',
            labelPosition: 'inline',
        },
        sepia: {
            min: 0,
            max: 100,
            label: 'Sepia',
            defaultUnit: '%',
            template: 'Range',
            defaultValue: '0%',
            labelWidth: '103px',
            labelPosition: 'inline',
        },
        grayscale: {
            min: 0,
            max: 100,
            defaultUnit: '%',
            label: 'Grayscale',
            template: 'Range',
            defaultValue: '0%',
            labelWidth: '103px',
            labelPosition: 'inline',
        },
        invert: {
            min: 0,
            max: 100,
            label: 'Invert',
            defaultUnit: '%',
            template: 'Range',
            defaultValue: '0%',
            labelWidth: '103px',
            labelPosition: 'inline',
        },
        opacity: {
            min: 0,
            max: 100,
            hoverable: true,
            label: 'Opacity',
            defaultUnit: '%',
            template: 'Range',
            defaultValue: '100%',
        },
        blur: {
            max: 20,
            label: 'Blur',
            hoverable: true,
            defaultUnit: 'px',
            template: 'Range',
            defaultValue: '0px',
        },
    },
    textShadow: {
        x: {
            template: 'Range',
            defaultUnit: 'px',
            labelWidth: '98px',
            label: 'Horizontal',
            labelPosition: 'inline',
        },
        y: {
            template: 'Range',
            defaultUnit: 'px',
            labelWidth: '98px',
            label: 'Vertical',
            labelPosition: 'inline',
        },
        blur: {
            label: 'Blur',
            defaultUnit: 'px',
            template: 'Range',
            labelWidth: '98px',
            labelPosition: 'inline',
        },
        color: {
            hoverable: true,
            template: 'ColorPicker',
            label: 'Text Shadow Color',
        },
        _enabled: {
            onValue: true,
            onLabel: 'ON',
            offValue: false,
            offLabel: 'OFF',
            template: 'Switch',
            defaultValue: false,
            label: 'Text Shadow',
        },
    },

    transition: {
        max: 1000,
        defaultValue: '',
        defaultUnit: 'ms',
        template: 'Range',
        allowedUnits: ['ms', 's'],
        label: 'Hover Transition',
    },
};
